import { Icon } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Card, Button, Title } from 'UI';
import styles from './WorkflowToggleDialog.module.scss';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

export default function DeactivateWithoutSubAccountsDialog({ onConfirm, onCancel }: Props) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.ToggleDialog.Deactivate.WithoutSubAccounts',
  });

  return (
    <Card hoverEffect={false} className={styles.card}>
      <div className={styles.iconWrapper}>
        <Icon icon="cautionary2" size="xxlg" width="60px" height="60px" color="none" />
      </div>

      <Title level="4" className={styles.title}>
        {t('title', { defaultValue: 'Deactivate Workflow' })}
      </Title>

      <div className={styles.body}>
        <p className={styles.subtitle}>{t('subtitle', { defaultValue: 'Deactivating this workflow will:' })}</p>
        <ul className={styles.bullets}>
          <li>
            {t('bullet1', {
              defaultValue: 'Deactivate it on this account only. Sub-accounts are not affected.',
            })}
          </li>
          <li>
            {t('bullet2', {
              defaultValue: 'Automatically approve any transactions currently pending approval.',
            })}
          </li>
        </ul>
        <p className={styles.footer}>
          {t('footer', {
            defaultValue: "The workflow's settings will be preserved. You can re-activate it later.",
          })}
        </p>
      </div>

      <div className={styles.controls}>
        <Button colorScheme="secondary" size="small" onClick={onCancel}>
          {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button colorScheme="primary" size="small" onClick={onConfirm}>
          {t('confirmButton', { defaultValue: 'Deactivate Workflow' })}
        </Button>
      </div>
    </Card>
  );
}
